{
    "components": {
        "buttons": {
            "default": {
                "add_to_cart": {
                    "label": "Añadir al carrito"
                },
                "back": {
                    "label": "Atrás"
                },
                "cancel": {
                    "label": "Cancelar"
                },
                "close": {
                    "label": "Cerrar"
                },
                "confirm": {
                    "label": "Confirmar"
                },
                "delete": {
                    "label": "Eliminar"
                },
                "edit": {
                    "label": "Editar"
                },
                "next": {
                    "label": "Siguiente"
                },
                "previous": {
                    "label": "Anterior"
                },
                "proceed_configuration": {
                    "label": "Continuar"
                },
                "save": {
                    "label": "Guardar"
                },
                "start_ordering": {
                    "label": "Comenzar a pedir"
                },
                "upload_photo": {
                    "label": "Subir foto"
                }
            },
            "previous_page": {
                "label": "Página anterior"
            },
            "close": {
                "label": "Cerrar"
            }
        },
        "discount_blocks": {
            "code_copied": "¡Código copiado!"
        },
        "dropdown": {
            "menu_button": {
                "label": "Menú"
            }
        },
        "footer": {
            "newsletter": {
                "title": "No te pierdas nunca más una oferta",
                "subtitle": "Suscríbete a nuestro boletín",
                "email_label": "Correo electrónico",
                "submit_button": "Enviar"
            }
        },
        "header": {
            "all_categories_line_1": "Ver todas las",
            "all_categories_line_2": "categorías",
            "search_aria_label": "Buscar",
            "search_close_aria_label": "Cerrar búsqueda",
            "search_placeholder": "¿Qué estás buscando?",
            "search_all_designs_title": "Todos los diseños para ‘{query}’",
            "search_all_designs_label": "diseños",
            "search_suggestions_title": "Sugerencias de búsqueda",
            "search_products_title": "Productos",
            "search_no_results_title": "No hay diseños para ‘{query}’",
            "search_no_results_hint": "Comprueba la ortografía o prueba con una palabra más amplia.",
            "search_scope_all_products": "Todos los productos",
            "search_scope_products": "Producto…",
            "search_all_designs_title_scoped": "Todos los diseños para ‘{query}’ en {group}",
            "search_scope_reset": "Buscar ‘{query}’ en todos los productos",
            "search_popular_on_title": "Popular en {name}",
            "search_categories_title": "Categorías"
        },
        "layouts": {
            "login_status": {
                "cart": {
                    "label": "Carrito"
                },
                "login": {
                    "label": "Iniciar sesión"
                },
                "welcome": {
                    "label": "Bienvenido,"
                },
                "welcome_back": {
                    "label": "Bienvenido de nuevo"
                }
            },
            "mobile_menu_button": {
                "label": "Menú"
            },
            "mobile_menu_drawer": {
                "back_to_categories": "Volver a todas las categorías",
                "close": "Cerrar menú",
                "default_title": "Menú",
                "view_all": "Ver todo {title}",
                "expand_submenu": "Expandir submenú"
            }
        },
        "select_menus": {
            "default": {
                "placeholder": "Seleccionar opción"
            }
        },
        "spinners": {
            "default": {
                "label": "Cargando..."
            }
        },
        "header_slider": {
            "timer": {
                "days": "d",
                "hours": "h",
                "minutes": "m",
                "seconds": "s"
            }
        },
        "modals": {
            "register": {
                "has_account": "¿Ya tienes una cuenta?",
                "general_error": "No se ha podido crear la cuenta. Inténtalo de nuevo."
            },
            "login": {
                "title": "Iniciar sesión"
            }
        },
        "wishlist": {
            "button": {
                "add_aria_label": "Añadir a la lista de deseos",
                "remove_aria_label": "Eliminar de la lista de deseos"
            },
            "header_button": {
                "aria_label": "Lista de deseos"
            },
            "toast": {
                "removed": "Eliminado de tu lista de deseos",
                "undo": "Deshacer"
            },
            "guest_added": {
                "title": "Lista de deseos",
                "success": "Añadido a tu lista de deseos",
                "login_prompt": "{login} o {register} para guardar tu lista de deseos en todos tus dispositivos y compartirla.",
                "login": "Inicia sesión",
                "register": "crea una cuenta",
                "continue_shopping": "Seguir comprando",
                "view_wishlist": "Ver lista de deseos"
            }
        },
        "related_products": {
            "title": "Elige tu diseño",
            "show_all": "Ver todo",
            "show_less": "Ver menos",
            "section_title": "Descubre más de esta colección"
        },
        "same_kind_products": {
            "title": "Estos también te encantarán"
        },
        "same_print_products": {
            "title": "Esta estampación en más productos"
        },
        "pdp_steps": {
            "step_label": "Paso {number}"
        },
        "pdp_review_videos": {
            "play_label": "Reproducir reseña en vídeo de {name}"
        },
        "video": {
            "play_label": "Reproducir vídeo"
        },
        "slider": {
            "go_to_item": "Ir al elemento {index} de {total}"
        },
        "lightbox": {
            "counter": "{current} de {total}"
        },
        "share": {
            "copy": "Copiar enlace",
            "copied": "Enlace copiado",
            "more": "Más",
            "sms": "Mensajes",
            "email": "Correo"
        }
    },
    "general": {
        "delivery_options": {
            "day_after_tomorrow": {
                "label": "¡Pide hoy, recíbelo <b>pasado mañana</b>!"
            },
            "delivered_in_days": {
                "label": "Entrega en <b>{days} días</b>"
            },
            "delivered_in_business_days": {
                "label": "¡Pedido realizado hoy, entrega en {days} día hábil! | ¡Pedido realizado hoy, entrega en {days} días hábiles!"
            },
            "today_delivery": {
                "label": "¡Pide hoy, recíbelo <b>hoy</b>!"
            },
            "tomorrow_delivery": {
                "label": "¡Pide hoy, recíbelo <b>mañana</b>!"
            }
        },
        "password": {
            "confirmation": {
                "label": "Confirmar contraseña"
            },
            "confirmation_new": {
                "label": "Confirmar nueva contraseña"
            },
            "current": {
                "label": "Contraseña actual"
            },
            "label": "Contraseña",
            "mismatch": "Las contraseñas no coinciden, por favor comprueba los campos de nuevo.",
            "new": {
                "label": "Nueva contraseña"
            },
            "requirements": "Usa 3 tipos diferentes de caracteres. Caracteres posibles: letras minúsculas, letras mayúsculas, números y caracteres especiales."
        },
        "price_tables": {
            "entries": {
                "amount_label": "1 pieza | {count} piezas",
                "all_sizes": "Todos los tamaños"
            },
            "title": {
                "amount": "Cantidad",
                "size": "Tamaño"
            }
        },
        "prices": {
            "excl_discount": {
                "label": "Precio sin descuento"
            },
            "for": {
                "label": "Para"
            },
            "from": {
                "label": "Desde"
            },
            "starting_from": {
                "label": "Desde"
            },
            "title": "Precios",
            "total": {
                "label": "Total"
            }
        },
        "product_description": {
            "title": "Descripción del producto"
        },
        "question_and_answers": {
            "no_data": {
                "primary_text": "No se encontraron preguntas ni respuestas."
            },
            "title": "Preguntas y respuestas",
            "subtitle": "Lo que los clientes preguntan con más frecuencia."
        },
        "reviews": {
            "buyer": "Comprador",
            "customer_images": "Imágenes de clientes",
            "view_more_images": "Ver más",
            "filter_all_stars": "Mostrar todo",
            "filter_label": "Filtro",
            "filter_stars": "1 estrella | {count} estrellas",
            "highest_rated_title": "Reseñas de clientes",
            "no_reviews_title": "Aún no hay reseñas escritas",
            "no_reviews_description": "Hay 1 valoración de {rating} estrellas. | Hay {votes} valoraciones con una media de {rating} estrellas.",
            "image_alt": "Imagen de la reseña",
            "no_results_for_filter": "No hay reseñas para este filtro.",
            "read_full_review": "Leer reseña completa",
            "review_amount": "{count} valoración | {count} valoraciones",
            "review_count": "{votes} valoraciones, de las cuales {reviewCount} escritas",
            "show_all_reviews": "Mostrar las {count} reseñas de clientes",
            "show_less": "Mostrar menos",
            "show_original": "Esta es una traducción, mostrar original",
            "show_star_reviews": "Mostrar reseñas de {score} estrellas",
            "show_translation": "Mostrar traducción",
            "title": "Reseñas de clientes",
            "about": "Sobre:",
            "read_more": "Leer más",
            "show_all": "Ver las {count}",
            "votes_count": "1 valoración | {count} valoraciones"
        },
        "shipping_options": {
            "title": "Opciones de entrega"
        },
        "show_more_products": "Mostrar más productos",
        "stock": {
            "available": "Disponible en stock inmediatamente"
        },
        "checkout": {
            "title": "Finalizar compra"
        },
        "filter_amount_products": "Filtrar {count} productos",
        "pickup_points": {
            "pickup_location": {
                "confirmed": "Punto de recogida seleccionado!",
                "select": "Recoger aquí"
            }
        },
        "price_table": {
            "filters": {
                "show_less": "Mostrar menos tallas",
                "show_more": "Mostrar más tamaños"
            }
        },
        "show_less_collections": "Mostrar menos colecciones",
        "show_more_collections": "Mostrar más colecciones",
        "show_more": "Mostrar más",
        "show_less": "Mostrar menos",
        "product_details": "Información del producto"
    },
    "pages": {
        "cart_page": {
            "add_product": "Añadir otro producto",
            "coupon_applied": "Código de descuento aplicado.",
            "coupon_apply_failed": "El código de descuento no pudo aplicarse.",
            "free_shipping_remaining": "Te faltan {amount} para el {free}",
            "free_shipping_goal": "envío gratuito",
            "free_shipping_exception": "Excepto paquetes XXL",
            "no_items_proceed_shopping_link": "aquí",
            "overview_title": "Resumen",
            "pages_count": "{count} páginas",
            "quantity_update_failed": "La cantidad no puede actualizarse.",
            "remove_modal": {
                "cancel": "Cancelar",
                "confirm": "¿Seguro que quieres quitar este producto del carrito?",
                "set_confirm": "Si eliminas este producto, el descuento del set dejará de aplicarse a los demás productos. ¿Seguro que quieres eliminarlo?",
                "title": "Eliminar producto",
                "yes": "Sí, eliminar"
            },
            "cart_item": {
                "delete": "Eliminar",
                "edit": "Editar",
                "edit_failed": "No se ha podido abrir el producto para editarlo. Inténtalo de nuevo.",
                "quantity": {
                    "label": "Cantidad"
                },
                "set_count": "{count} producto | {count} productos",
                "show_details": "Mostrar detalles"
            },
            "messages": {
                "success": {
                    "deleted": "El producto ha sido eliminado de su carrito."
                }
            },
            "no_items": "No tiene productos en su carrito.",
            "overview": {
                "coupon_code": {
                    "button": {
                        "label": "Aplicar"
                    },
                    "cancel": "Cancelar",
                    "input": {
                        "placeholder": "Introduzca el código de descuento"
                    },
                    "title": "Introduzca un código de descuento"
                },
                "coupon_code_display": "Código de descuento ({code})",
                "coupon_codes_display": "Códigos de cupón",
                "discount_display": "Descuento",
                "item_count": "1 artículo | {count} artículos",
                "prices": {
                    "discount": "Ahorro",
                    "grand_total": "Total",
                    "shipping": "Envío",
                    "subtotal": "Subtotal",
                    "tax": "IVA",
                    "tax_included": "IVA incluido: {amount}",
                    "total_incl_tax": "Subtotal (IVA incl.)"
                }
            },
            "proceed_to_checkout": "Finalizar compra",
            "title": "Carrito",
            "no_items_proceed_shopping": "Haga clic {link} para seguir comprando.",
            "free_shipping": "Envío gratuito",
            "free_shipping_reached": "{free} para tu pedido",
            "checkout_hint": "A continuación: elige la dirección y el momento de entrega"
        },
        "category": {
            "filters_title": "Filtrar",
            "clear_all": "Borrar todo",
            "selected_count": "{count} seleccionado(s)",
            "selected_filters": "Filtros seleccionados",
            "hierarchy_all": "Todo {label}",
            "close_filters": "Cerrar filtros",
            "no_filter_options_available": "No hay opciones de filtro disponibles",
            "no_image": "Sin imagen",
            "open_grid_view": "Abrir vista de cuadrícula",
            "open_list_view": "Abrir vista de lista",
            "open_two_column_view": "Abrir vista de 2 columnas",
            "products": {
                "label": "productos",
                "prices": {
                    "recommended_price": "demás"
                }
            },
            "remove_filter": "Eliminar filtro {filter}: {value}",
            "show_results": "Mostrar resultados",
            "show_results_with_count": "Mostrar {count} resultados",
            "clear_filters": "Eliminar todos los filtros",
            "filter": "Filtrar",
            "show_less_filters": "Mostrar menos",
            "show_more_filters": "Mostrar más",
            "faqs": {
                "title": "Preguntas frecuentes"
            },
            "header": {
                "header_description": {
                    "show_more": "Más",
                    "show_less": "Menos"
                }
            },
            "filter_explanation": "Más información sobre este filtro"
        },
        "collection": {
            "delivery_options": {
                "pickup_point": "Punto de recogida (opción sostenible)"
            }
        },
        "customers": {
            "dashboard": {
                "account_information": {
                    "form": {
                        "assistance_allowed_label": "Permitir asistencia remota durante las compras",
                        "assistance_allowed_tooltip": "Esto permite al personal ver tu pantalla y realizar acciones en tu nombre para ayudarte mejor durante las compras.",
                        "email_label": "Dirección de correo electrónico",
                        "first_name_label": "Nombre",
                        "last_name_label": "Apellido",
                        "legend": "Información de la cuenta",
                        "submit_button": "Guardar"
                    },
                    "index": {
                        "intro": "Mis datos de contacto y configuración de cuenta.",
                        "title": "Información de la cuenta"
                    }
                },
                "address": {
                    "billing_title": "Dirección de facturación predeterminada",
                    "description": "Dirección de facturación y envío predeterminada actual.",
                    "legend": "Libreta de direcciones",
                    "manage_link": "Gestionar direcciones",
                    "shipping_title": "Dirección de envío predeterminada"
                },
                "addresses": {
                    "create": {
                        "intro": "Añade una nueva dirección a la libreta de direcciones.",
                        "title": "Nueva dirección"
                    },
                    "default_cards": {
                        "empty_state": "Aún no se ha establecido ninguna dirección predeterminada."
                    },
                    "edit": {
                        "intro": "Edita una dirección existente de la libreta de direcciones.",
                        "title": "Editar dirección"
                    },
                    "form": {
                        "address_legend": "Dirección",
                        "city_label": "Ciudad",
                        "company_label": "Empresa",
                        "contact_legend": "Datos de contacto",
                        "countries": {
                            "AT": "Austria",
                            "BE": "Bélgica",
                            "DE": "Alemania",
                            "FR": "Francia",
                            "LU": "Luxemburgo",
                            "NL": "Países Bajos"
                        },
                        "country_label": "País",
                        "default_billing_label": "Usar como dirección de facturación predeterminada",
                        "default_shipping_label": "Usar como dirección de envío predeterminada",
                        "first_name_label": "Nombre",
                        "last_name_label": "Apellido",
                        "postcode_label": "Código postal",
                        "region_label": "Estado/Provincia",
                        "street1_label": "Dirección",
                        "street2_label": "Línea de dirección 2",
                        "submit_create_button": "Añadir dirección",
                        "submit_edit_button": "Guardar dirección",
                        "telephone_label": "Número de teléfono"
                    },
                    "index": {
                        "add_address_button": "Añadir dirección",
                        "billing_action_text": "Cambiar dirección de facturación",
                        "billing_title": "Dirección de facturación predeterminada",
                        "delete_modal_cancel_button": "Cancelar",
                        "delete_modal_confirm_button": "Eliminar",
                        "delete_modal_description": "¿Estás seguro de que quieres eliminar esta dirección?",
                        "delete_modal_title": "Eliminar dirección",
                        "intro": "Mis direcciones e información adicional.",
                        "shipping_action_text": "Cambiar dirección de envío",
                        "shipping_title": "Dirección de envío predeterminada",
                        "title": "Libreta de direcciones"
                    },
                    "list": {
                        "address_column": "Dirección",
                        "city_column": "Ciudad",
                        "company_column": "Empresa",
                        "country_column": "País",
                        "delete_label": "Eliminar",
                        "edit_title": "Editar",
                        "empty_state": "Aún no se han establecido otras direcciones.",
                        "legend": "Otras direcciones",
                        "name_column": "Nombre"
                    }
                },
                "empty_address_state": "Aún no se ha configurado ninguna dirección.",
                "intro": "¡Bienvenido {firstName}! A continuación encontrarás toda tu información y pedidos recientes.",
                "navigation": {
                    "account_information": "Información de la cuenta",
                    "address_book": "Libreta de direcciones",
                    "dashboard": "Panel",
                    "logout": "Cerrar sesión",
                    "orders": "Mis pedidos",
                    "projects": "Mis fotolibros",
                    "security": "Seguridad",
                    "title": "Mi cuenta",
                    "wishlist": "Lista de deseos"
                },
                "order_history": {
                    "detail": {
                        "header": {
                            "date_label": "Fecha"
                        },
                        "index": {
                            "back_button": "Volver al resumen de pedidos",
                            "intro": "Vista detallada de un pedido.",
                            "title": "Pedido #{number}"
                        },
                        "info": {
                            "billing_address_title": "Dirección de facturación",
                            "payment_method_title": "Método de pago",
                            "shipping_address_title": "Dirección de entrega",
                            "shipping_method_title": "Método de envío"
                        },
                        "items": {
                            "article_number_label": "Ref.",
                            "legend": "Artículos pedidos",
                            "price_column": "Precio",
                            "product_name_column": "Nombre del producto",
                            "quantity_column": "Cantidad",
                            "subtotal_column": "Subtotal"
                        },
                        "totals": {
                            "discount": "Descuento",
                            "grand_total": "Total (IVA incl.)",
                            "grand_total_excluding_tax": "Total (IVA excl.)",
                            "shipping": "Envío y gestión",
                            "subtotal": "Subtotal",
                            "tax": "IVA"
                        }
                    },
                    "index": {
                        "intro": "Resumen de mis pedidos realizados.",
                        "legend": "Mis pedidos",
                        "order_count": "{count} pedido | {count} pedidos",
                        "title": "Mis pedidos"
                    },
                    "table": {
                        "date_column": "Fecha",
                        "empty_state": "Aún no has realizado ningún pedido.",
                        "order_number_column": "N.° de pedido",
                        "status_column": "Estado",
                        "total_column": "Total",
                        "tracking_column": "Seguimiento",
                        "view_label": "Ver"
                    }
                },
                "orders": {
                    "date_column": "Fecha",
                    "empty_state": "Aún no has realizado ningún pedido.",
                    "legend": "Pedidos recientes",
                    "order_number_column": "N.° de pedido",
                    "shipping_to_column": "Enviar a",
                    "status_column": "Estado",
                    "total_column": "Total",
                    "view_all_link": "Ver todo",
                    "view_link": "Ver"
                },
                "profile": {
                    "create": {
                        "intro": "Añade una nueva dirección a la libreta de direcciones.",
                        "title": "Nueva dirección"
                    },
                    "edit": {
                        "intro": "Edita una dirección existente de la libreta de direcciones.",
                        "title": "Editar dirección"
                    },
                    "edit_link": "Editar la información de tu cuenta",
                    "form": {
                        "address_legend": "Dirección",
                        "city_label": "Ciudad",
                        "company_label": "Empresa",
                        "contact_legend": "Datos de contacto",
                        "country_label": "País",
                        "default_billing_label": "Usar como dirección de facturación predeterminada",
                        "default_shipping_label": "Usar como dirección de envío predeterminada",
                        "first_name_label": "Nombre",
                        "last_name_label": "Apellido",
                        "postcode_label": "Código postal",
                        "region_label": "Estado/Provincia",
                        "street1_label": "Dirección",
                        "street2_label": "Línea de dirección 2",
                        "submit_create_button": "Añadir dirección",
                        "submit_edit_button": "Guardar dirección",
                        "telephone_label": "Número de teléfono"
                    },
                    "legend": "Datos de contacto",
                    "list": {
                        "address_column": "Dirección",
                        "city_column": "Ciudad",
                        "company_column": "Empresa",
                        "country_column": "País",
                        "delete_label": "Eliminar",
                        "edit_title": "Editar",
                        "empty_state": "Aún no se han establecido otras direcciones.",
                        "legend": "Otras direcciones",
                        "name_column": "Nombre"
                    }
                },
                "projects": {
                    "index": {
                        "intro": "Mis proyectos guardados y fotolibros.",
                        "legend": "Mis fotolibros",
                        "title": "Mis fotolibros"
                    },
                    "list": {
                        "actions_column": "Acciones",
                        "empty_state": "Aún no has guardado ningún fotolibro.",
                        "fallback_text": "Vista previa del álbum de fotos",
                        "preview_alt": "Vista previa",
                        "preview_link": "Vista previa",
                        "product_column": "Producto",
                        "project_link": "Ir al proyecto",
                        "updated_at_column": "Última actualización"
                    }
                },
                "security": {
                    "form": {
                        "legend": "Cambiar contraseña",
                        "submit": "Guardar contraseña"
                    },
                    "index": {
                        "intro": "Actualiza aquí la contraseña de tu cuenta.",
                        "title": "Seguridad"
                    }
                },
                "title": "Mi cuenta",
                "wishlist": {
                    "index": {
                        "empty_state": "Tu lista de deseos está vacía.",
                        "intro": "Productos que has guardado.",
                        "legend": "Mi lista de deseos",
                        "title": "Lista de deseos",
                        "guest_notice": "Guardado en este dispositivo · {login} para ver tus artículos en todas partes",
                        "guest_notice_login": "Inicia sesión"
                    },
                    "share": {
                        "button": "Compartir",
                        "title": "Comparte tu lista de deseos con otros",
                        "description": "Cualquiera con este enlace puede ver tu lista de deseos."
                    },
                    "shared": {
                        "title": "Lista de deseos compartida",
                        "intro": "Estos productos se han compartido contigo."
                    }
                },
                "intro_no_name": "¡Bienvenido! A continuación encontrarás toda tu información y tus pedidos recientes."
            },
            "login": {
                "index": {
                    "create_account": "Crear cuenta",
                    "description": "Si tienes una cuenta, inicia sesión con tu dirección de correo electrónico.",
                    "email_label": "Dirección de correo electrónico",
                    "email_placeholder": "nombre{'@'}ejemplo.es",
                    "forgot_password": "¿Olvidaste tu contraseña?",
                    "intro": "Inicia sesión o crea una cuenta para acceder a tu panel de control.",
                    "legend": "Iniciar sesión",
                    "new_customers_description": "Crear una cuenta tiene muchos beneficios: pago más rápido, guardar múltiples direcciones, rastrear pedidos y más.",
                    "new_customers_legend": "Nuevos clientes",
                    "password_label": "Contraseña",
                    "password_placeholder": "Introduce tu contraseña",
                    "submit": "Iniciar sesión",
                    "title": "Iniciar sesión",
                    "sso_facebook": "Continuar con Facebook",
                    "sso_google": "Continuar con Google",
                    "sso_separator": "O"
                }
            },
            "passwords": {
                "forgot": {
                    "index": {
                        "back_button": "Volver al inicio de sesión",
                        "description": "Si existe una cuenta con la dirección de correo electrónico indicada, recibirás un correo electrónico.",
                        "email_label": "Dirección de correo electrónico",
                        "email_placeholder": "nombre{'@'}ejemplo.es",
                        "intro": "Introduce tu dirección de correo electrónico a continuación para recibir un enlace de restablecimiento de contraseña.",
                        "submit_button": "Enviar",
                        "title": "¿Olvidaste tu contraseña?"
                    }
                },
                "reset": {
                    "index": {
                        "intro": "Elige una nueva contraseña para tu cuenta a continuación.",
                        "submit": "Establecer una nueva contraseña",
                        "title": "Establecer nueva contraseña"
                    }
                }
            },
            "register": {
                "credentials": {
                    "email_label": "Dirección de correo electrónico",
                    "legend": "Datos de acceso",
                    "privacy_link": "Política de privacidad",
                    "privacy_prefix": "Acepto la"
                },
                "index": {
                    "back_button": "Volver al inicio de sesión",
                    "intro": "Crea una nueva cuenta para gestionar tus pedidos, direcciones y proyectos.",
                    "submit_button": "Crear cuenta",
                    "title": "Crear una nueva cuenta"
                },
                "profile": {
                    "first_name_label": "Nombre",
                    "last_name_label": "Apellido",
                    "legend": "Información personal",
                    "subscribe_label": "Suscribirse al boletín"
                }
            }
        },
        "errors": {
            "back_to_home": "Volver al inicio",
            "404": {
                "heading": "Página no encontrada.",
                "description": "No hemos podido encontrar la página que buscas. Es posible que el enlace haya caducado o que la página se haya movido."
            },
            "500": {
                "heading": "Algo ha salido mal.",
                "description": "Se ha producido un error inesperado de nuestra parte. Por favor, inténtalo de nuevo más tarde."
            },
            "403": {
                "heading": "Acceso denegado.",
                "description": "No tienes permiso para ver esta página."
            },
            "503": {
                "heading": "Temporalmente no disponible.",
                "description": "El sitio web no está disponible temporalmente. Por favor, inténtalo de nuevo más tarde."
            },
            "generic": {
                "heading": "Se ha producido un error.",
                "description": "Se ha producido un error inesperado. Por favor, inténtalo de nuevo más tarde."
            }
        },
        "product_detail_page": {
            "share": {
                "label": "Compartir esta página",
                "title": "Comparte este producto con otros"
            },
            "product_info": {
                "benefits": {
                    "title": "Las ventajas de {storeName}",
                    "payment_methods_label": "paga, entre otros, con"
                },
                "klarna": {
                    "loading": {
                        "label": "Klarna está cargando..."
                    }
                },
                "modals": {
                    "product_options_modal": {
                        "overview": {
                            "title": "Resumen"
                        },
                        "title": "Opciones del producto"
                    }
                },
                "product_button": {
                    "add_to_cart": {
                        "error": "Ha ocurrido un error al añadir al carrito.",
                        "loading": {
                            "description": "Serás redirigido automáticamente.",
                            "label": "Añadiendo al carrito..."
                        },
                        "set_error": "Ha ocurrido un error al añadir el set. Algunas partes pueden estar ya en tu carrito, así que revísalo antes de volver a intentarlo."
                    },
                    "book_login_modal": {
                        "continue_without_login": "Continuar sin iniciar sesión",
                        "continue_without_login_warning": "Si continúas sin iniciar sesión, tus fotos no se guardarán. No podrás editar ni completar tu producto más tarde.",
                        "description": "Inicia sesión para guardar tu progreso y continuar tu proyecto más tarde.",
                        "email_label": "Dirección de correo electrónico",
                        "email_placeholder": "nombre{'@'}ejemplo.es",
                        "forgot_password": "¿Olvidaste tu contraseña?",
                        "general_error": "Error al iniciar sesión. Comprueba tus datos e inténtalo de nuevo.",
                        "no_account": "¿Aún no tienes cuenta?",
                        "password_label": "Contraseña",
                        "password_placeholder": "Introduce tu contraseña",
                        "separator": "O",
                        "submit": "Iniciar sesión",
                        "title": "Iniciar sesión"
                    },
                    "new_project_modal": {
                        "description": "Dale un título a tu libro de fotos para encontrarlo fácilmente. Puedes cambiarlo más tarde.",
                        "submit": "Empezar a crear",
                        "title": "Nombra tu proyecto",
                        "title_hint": "{count} / 150",
                        "title_label": "Título del proyecto",
                        "title_placeholder": "Ej. Vacaciones {year}, Álbum familiar..."
                    },
                    "recent_projects_modal": {
                        "description": "Continúa con un proyecto de fotolibro existente o empieza uno nuevo.",
                        "empty_state": "Todavía no tienes proyectos recientes de fotolibro.",
                        "error": "Ha ocurrido un error al cargar tus proyectos.",
                        "loading": "Cargando tus proyectos recientes...",
                        "next_page": "Siguiente",
                        "open_error": "No se pudo abrir el proyecto. Inténtalo de nuevo.",
                        "open_project": "Abrir proyecto",
                        "opening": "Abriendo...",
                        "pagination": "Página {page} de {total}",
                        "previous_page": "Anterior",
                        "retry": "Volver a intentar",
                        "sheet_count": "{count} páginas",
                        "start_new_project": "Empezar un proyecto nuevo",
                        "title": "Proyectos recientes",
                        "updated_at": "Última edición: {date}"
                    },
                    "start_ordering": {
                        "loading": {
                            "description": "Estamos preparando el diseñador para ti.",
                            "label": "Tu producto se está preparando..."
                        }
                    },
                    "start_over": {
                        "confirm_modal": {
                            "cancel": "Cancelar",
                            "confirm": "Sí, empezar de nuevo",
                            "description": "Se eliminarán tu foto actual y tus ajustes. Esta acción no se puede deshacer.",
                            "title": "¿Seguro que quieres empezar de nuevo?"
                        },
                        "label": "O empezar de nuevo, elige una nueva foto"
                    },
                    "upload": {
                        "errors": {
                            "file_too_large": "Esta foto es demasiado grande. Sube una imagen de máximo 100 MB.",
                            "generic": "Algo salió mal durante la carga. Inténtalo de nuevo.",
                            "invalid_file_type": "Este tipo de archivo no es compatible. Sube una imagen JPG, PNG o WebP.",
                            "retry_cta": "Intentar de nuevo",
                            "title": "Error al subir"
                        },
                        "leave_modal": {
                            "cancel": "Quedarme aquí",
                            "confirm": "Detener subida",
                            "description": "Tu foto todavía se está subiendo. Si sales ahora, perderás el progreso.",
                            "title": "¿Seguro que quieres salir?"
                        },
                        "offline": {
                            "description": "Estás sin conexión. Continuaremos donde lo dejamos cuando vuelvas a estar en línea.",
                            "title": "Sin conexión"
                        },
                        "redirecting": {
                            "description": "Está siendo redirigado.",
                            "label": "¡Carga completada!"
                        },
                        "uploading": {
                            "description": "Está siendo redirigido automáticamente.",
                            "label": "Tu foto está siendo procesada..."
                        }
                    },
                    "update_cart": {
                        "loading": {
                            "description": "Serás redirigido automáticamente al carrito.",
                            "label": "Tu producto se está actualizando."
                        }
                    },
                    "force_size_selection_message": "Por favor, selecciona un tamaño antes de continuar.",
                    "force_size_selection_tooltip": "Todavía tienes que seleccionar un tamaño"
                },
                "product_filters": {
                    "choose_option": "Selecciona una opción",
                    "make_your_choice": "Haz tu elección"
                },
                "product_set": {
                    "available_sizes_label": "Elige tus formatos",
                    "discount_label": "Descuento de set",
                    "position_label": "Imagen {number}",
                    "save_label": "Guardar",
                    "standard_sizes_note": "Las imágenes se basan en formatos estándar"
                },
                "switch_options": {
                    "with_name": "Con nombre",
                    "without_name": "Sin nombre"
                }
            },
            "user_text": {
                "error": {
                    "empty": "No se ha introducido ningún texto"
                },
                "label": "Texto personal",
                "placeholder": "Introduce tu texto..."
            },
            "price": {
                "from_abbreviation": "desde",
                "instead_of": "en lugar de"
            },
            "after_upload_text": "Luego: elija un formato y consulte los precios.",
            "timer": {
                "label": "{days} días y {hours}:{minutes}:{seconds}",
                "last_day_label": "Solo quedan {hours} horas y {minutes}:{seconds}",
                "one_day_label": "{days} día y {hours}:{minutes}:{seconds}"
            },
            "ai_upload": {
                "history": {
                    "loading_previous": "Cargando tu versión anterior",
                    "loading_latest": "Cargando tu versión más reciente"
                },
                "auth": {
                    "email": {
                        "continue": "Continuar",
                        "context": "Introduce tu dirección de correo electrónico para subir tu propia foto y generarla con IA.",
                        "error": "Algo ha salido mal. Inténtalo de nuevo.",
                        "placeholder": "Tu dirección de correo electrónico",
                        "title": "Continuar"
                    },
                    "login": {
                        "context": "Ya existe una cuenta para {email}. Inicia sesión para continuar.",
                        "forgot_password": "¿Olvidaste tu contraseña?",
                        "general_error": "Error al iniciar sesión. Comprueba tus datos e inténtalo de nuevo.",
                        "password_placeholder": "Introduce tu contraseña",
                        "submit": "Iniciar sesión",
                        "title": "Iniciar sesión"
                    },
                    "otp": {
                        "general_error": "Algo ha salido mal. Inténtalo de nuevo.",
                        "intro": "Te hemos enviado un código de verificación a {email}.",
                        "resend": "¿No recibiste el código? Reenviar",
                        "resend_sent": "Te hemos enviado un nuevo código.",
                        "submit": "Confirmar y elegir foto",
                        "title": "Confirma tu correo electrónico",
                        "submit_continue": "Confirmar"
                    },
                    "success": {
                        "title": "¡Sesión iniciada!",
                        "cta": "Selecciona tu foto"
                    }
                },
                "ai_generated_badge": "Generado por IA",
                "view_full_screen": "Ver la foto a pantalla completa",
                "button": {
                    "label": "Empieza tu pedido",
                    "choose_photo": "Elige tu foto",
                    "try_again": "Intentar de nuevo",
                    "offline": "Sin conexión. La subida continuará automáticamente cuando se restaure la conexión.",
                    "slow_connection": "Tienes una conexión lenta. La carga puede tardar un poco más.",
                    "add_text": "Añadir nombre/texto",
                    "edit_text": "Editar nombre/texto",
                    "errors": {
                        "invalid_file_type": "Este tipo de archivo no es compatible. Sube una foto en formato JPG, PNG o WEBP.",
                        "file_too_small": "Este archivo es demasiado pequeño. Elige otra foto.",
                        "file_too_large": "Este archivo es demasiado grande. Sube una foto de 100 MB o menos."
                    }
                },
                "progress": {
                    "retry": "Intentar de nuevo",
                    "retry_different_photo": "Subir una foto diferente",
                    "beauty_shots_failed": "Desafortunadamente, no pudimos crear las vistas previas de tu producto. Por favor, inténtalo de nuevo.",
                    "overtime": "Esto está tardando un poco más de lo esperado. Seguimos trabajando, por favor espera.",
                    "shot_pending": "Esta foto del producto se está creando todavía. Las demás ya puedes verlas.",
                    "creating_previews": "Ahora estamos creando las vistas previas de tu producto...",
                    "title": "Tu retrato se está creando",
                    "subtitle": "De media 60-90 segundos. Gracias por tu paciencia.",
                    "baking_title": "Estamos creando nuevas imágenes del producto para ti",
                    "bake_progress_title": "Cargando nuevas imágenes del producto",
                    "bake_progress_subtitle": "Se están creando nuevas imágenes del producto a partir de tu nombre.",
                    "preparing_photo_error": "No pudimos preparar tu foto de producto. Por favor, inténtalo de nuevo.",
                    "preparing_photo_and_cart_title": "Añadiendo tu producto al carrito",
                    "preparing_photo_and_cart_description": "Mientras tanto, terminamos tu foto de producto personalizada.",
                    "beauty_shots_count": "{completed} de {total}",
                    "steps": {
                        "analyzing": "Analizando foto",
                        "recognizing": "Reconociendo rostro",
                        "styling": "Aplicando estilo",
                        "finalizing": "Finalizando diseño",
                        "creating_images": "Creando imágenes",
                        "uploading": "Procesando tu foto",
                        "generating": "Creando tu imagen",
                        "processing": "Finalizando tu retrato",
                        "processing_plural": "Finalizando tus retratos",
                        "previews": "Creando imágenes del producto",
                        "preview_single": "Creando tu imagen de producto",
                        "preview_plural": "Creando tus imágenes de producto",
                        "uploading_busy": "Esto está tardando un poco más de lo esperado...",
                        "analyzing_busy": "Analizando con cuidado...",
                        "generating_busy": "Creando tu imagen...",
                        "generating_busy_plural": "Creando tus imágenes...",
                        "processing_busy": "Últimos retoques...",
                        "previews_busy": "Tus imágenes de producto se están creando, un momento...",
                        "baking_text": "Procesando texto...",
                        "baking_style": "Aplicando texto y estilo",
                        "baking_text_subtitle": "Tu texto se está aplicando al retrato.",
                        "baking_photo": "Actualizando imagen del producto",
                        "addition_activating": "Cargando estilo {label}",
                        "addition_transforming": "Transformando retrato",
                        "addition_transforming_subtitle": "Estamos transformando tu retrato",
                        "addition_generating": "Generando {label}",
                        "addition_finalizing": "Finalizando detalles",
                        "uploading_subtitle": "Preparamos tu foto para la IA",
                        "analyzing_subtitle": "Vemos qué aparece en tu foto",
                        "generating_subtitle": "La IA está creando tu imagen",
                        "generating_subtitle_plural": "La IA está creando tus imágenes",
                        "processing_subtitle": "Damos los últimos retoques",
                        "addition_activating_subtitle": "Cargamos el estilo que elegiste",
                        "uploading_done": "Foto procesada",
                        "analyzing_done": "Foto analizada",
                        "generating_done": "Imagen creada",
                        "generating_done_plural": "Imágenes creadas",
                        "processing_done": "Detalles terminados",
                        "addition_activating_done": "Estilo cargado",
                        "addition_transforming_done": "Vista previa lista"
                    },
                    "image_failed": "No se ha podido crear esta imagen de producto."
                },
                "regenerate": {
                    "title": "Generar de nuevo",
                    "feedback_placeholder": "\"Más realista\" o \"Colores más vivos\"",
                    "with_feedback": "Con comentario",
                    "error_generic": "Algo salió mal. Inténtalo de nuevo.",
                    "threshold_exceeded": "Se ha alcanzado el límite diario de generación de fotos con IA. Inténtalo de nuevo mañana.",
                    "style_additions_generate": "Generar con {label}",
                    "style_additions_cost_notice": "Esto usa 1 crédito de IA",
                    "style_additions_title": "Elegir un complemento"
                },
                "crop": {
                    "panel_title": "Selecciona tu cara",
                    "panel_description": "Usa el recuadro de selección para enmarcar tu cara y obtener el mejor resultado.",
                    "image_load_error": "No pudimos cargar tu foto. Por favor, intenta con una imagen diferente.",
                    "zoom_in": "Acercar",
                    "zoom_out": "Alejar",
                    "validating": "Revisando foto…",
                    "error_title": "No ha funcionado"
                },
                "validation": {
                    "retry": "Elegir otra foto",
                    "cancel": "Cancelar",
                    "no_face": {
                        "title": "Cara no reconocida",
                        "description": "No hemos reconocido una cara clara en tu selección. Mueve la selección sobre la cara o sube otra foto.",
                        "tip_1": "Mira directamente a la cámara.",
                        "tip_2": "Asegúrate de tener buena iluminación — evita el contraluz.",
                        "tip_3": "Quítate las gafas de sol, mascarillas o gorras."
                    },
                    "no_pet": {
                        "title": "No se detectó ninguna mascota",
                        "description": "No pudimos detectar una mascota en tu foto. Sube una foto en la que tu mascota sea claramente visible."
                    },
                    "mismatch": {
                        "title": "No se detectó ninguna persona",
                        "description": "No hemos reconocido a ninguna persona en tu selección. Mueve la selección sobre la cara o sube otra foto.",
                        "tip_1": "Mueve la selección para que la cara quede dentro del recuadro.",
                        "tip_2": "O sube una foto en la que la persona se vea claramente."
                    },
                    "unsafe": {
                        "title": "Foto no aceptada",
                        "description": "Tu foto no cumple con nuestras directrices. Sube otra foto.",
                        "tip_1": "Utiliza una foto de retrato neutra y adecuada."
                    },
                    "unavailable": {
                        "title": "Comprobación de foto no disponible",
                        "description": "La comprobación de foto no está disponible temporalmente. Tu foto se ha enviado tal como está.",
                        "tip_1": "Inténtalo más tarde si tienes algún problema."
                    }
                },
                "daily_limit_reached": "La generación de fotos con IA no está disponible temporalmente. Inténtalo de nuevo mañana.",
                "user_daily_limit_reached": "Has alcanzado tu límite de generación de IA. Inténtalo de nuevo en 1 hora. | Has alcanzado tu límite de generación de IA. Inténtalo de nuevo en {count} horas.",
                "related_styles": {
                    "title": "Estilos de IA"
                },
                "view_previous_generations": "Ver generaciones anteriores",
                "transfer": {
                    "title": "Reutiliza tu foto anterior",
                    "dismiss": "Usar otra foto",
                    "generate": "Generar ahora",
                    "photo_label": "Tu foto",
                    "change": "Cambiar foto"
                },
                "beauty_shots_generating": "{count} foto de producto aún generándose... | {count} fotos de producto aún generándose...",
                "personalization": {
                    "alignment_label": "Alineación",
                    "weight_label": "Grosor",
                    "reset_text": "Restablecer el texto",
                    "remove_text": "Eliminar el texto",
                    "remove_all_text": "Empezar de nuevo",
                    "weight_300": "Fino",
                    "weight_400": "Normal",
                    "weight_500": "Medio",
                    "weight_600": "Seminegrita",
                    "weight_700": "Negrita",
                    "weight_800": "Extra negrita",
                    "weight_900": "Negro",
                    "uncommitted_modal_title": "El texto aún no se ha generado",
                    "uncommitted_modal_body": "Has añadido texto, pero todavía no se ha generado sobre la foto.",
                    "uncommitted_add_without_text": "Pedir sin texto",
                    "uncommitted_generate": "Generar y comprobar",
                    "uncommitted_cancel": "Seguir personalizando",
                    "uncommitted_generate_and_add": "Generar y continuar",
                    "uncommitted_next_product_options": "Después elegirás las opciones de tu producto.",
                    "uncommitted_next_redirect_to_cart": "Después se te redirigirá automáticamente a tu cesta.",
                    "active_banner": "Otras fotos bloqueadas",
                    "active_banner_tooltip": "Estás en modo de personalización. Contrae la personalización para volver a ver las otras fotos, o genera una vista previa.",
                    "remove": "Eliminar texto",
                    "drag_hint": "Arrastra para mover",
                    "update_preview": "Guardar y previsualizar",
                    "add_text": "Añadir texto",
                    "generating": "Generando...",
                    "committed_hint": "Elimina un texto para volver a la vista previa original.",
                    "background_padding_label": "Relleno",
                    "color_label": "Color del texto",
                    "font_label": "Fuente",
                    "mode_text": "Texto",
                    "preview_mode": "Modo de vista previa: aún no generado",
                    "size_label": "Tamaño",
                    "text_placeholder": "Tu texto aquí",
                    "title": "Añadir texto",
                    "title_update": "Actualizar personalización",
                    "field_label": "Nombre/texto",
                    "cta_add": "Añadir",
                    "cta_edit": "Editar",
                    "edit_baked_text": "Cambiar el texto",
                    "edit_baked_notice": "Tu texto ya forma parte de la imagen. Si lo cambias, volvemos a crear las fotos con el nuevo texto.",
                    "view_photos": "Ver todas las fotos",
                    "mobile_save": "Guardar",
                    "text_done": "Guardar el texto"
                },
                "cycle_limit_go_back": "← Ver resultados anteriores",
                "cycle_limit_reached_with_previous_title": "Has agotado todos tus intentos",
                "user_limit_reached_unknown_wait": "Has alcanzado tu límite de generación de IA. Inténtalo de nuevo más tarde.",
                "status": {
                    "loading": {
                        "label": "Tu foto se está subiendo",
                        "description": "Después te llevaremos automáticamente al siguiente paso."
                    },
                    "offline": {
                        "title": "Sin conexión",
                        "description": "Estás sin conexión. Continuaremos donde lo dejamos cuando vuelvas a estar en línea."
                    },
                    "errors": {
                        "title": "Error al subir",
                        "generic": "Algo salió mal durante la carga. Inténtalo de nuevo.",
                        "retry_cta": "Intentar de nuevo"
                    }
                }
            }
        },
        "product_options": {
            "preview_alt": "Vista previa",
            "saved_price": "Ahorras {amount}",
            "title": "Resumen de tu producto",
            "preview_loading": "Cargando la vista previa...",
            "update_cart": "Actualizar carrito"
        },
        "tools": {
            "add_to_cart_error": {
                "description": "No pudimos añadir tu producto al carrito. No te preocupes — tu configuración está guardada.",
                "retry": "Intentar de nuevo",
                "title": "Algo salió mal"
            },
            "ai": {
                "crop": {
                    "title": "Recortar",
                    "sidebar": "Herramientas de recorte"
                },
                "select": {
                    "title": "Elegir",
                    "heading": "Elige tu favorita",
                    "description": "Elige la versión que más te guste.",
                    "candidate_label": "Versión {number}",
                    "name_placeholder": "Tu nombre",
                    "candidate_pending": "Esta versión aún se está creando…",
                    "candidate_failed": "No se ha podido crear esta versión.",
                    "candidate_retry": "Intentar de nuevo",
                    "candidate_selected": "Seleccionada",
                    "select_candidate": "Elegir la versión {number}",
                    "view_larger": "Ver la versión {number} más grande",
                    "choose_this": "Elegir esta",
                    "show_all": "Mostrar todas mis imágenes",
                    "limit_reached": "Has alcanzado tu límite de generación. Elige entre las imágenes que ya tienes.",
                    "regenerate_question": "¿No te convencen?",
                    "regenerate": "Crea dos nuevas",
                    "regenerating": "Generando dos más…",
                    "regenerate_error": "No hemos podido generar más imágenes. Inténtalo de nuevo más tarde.",
                    "save_error": "No hemos podido guardar tu elección. Inténtalo de nuevo."
                },
                "configurator": {
                    "title": "Personalizar",
                    "sidebar": "Texto",
                    "panel_title": "Añade tu texto",
                    "name_required_hint": "Escribe tu propio nombre para continuar.",
                    "view_preview_button": "Ver vista previa",
                    "preparing": {
                        "loading": {
                            "label": "Creando la imagen de tu producto",
                            "description": "Un momento…"
                        }
                    }
                },
                "preview": {
                    "title": "Vista previa",
                    "shot_pending": "Esta imagen aún se está creando…",
                    "shot_failed": "No se ha podido crear esta imagen.",
                    "retry_shot": "Intentar de nuevo",
                    "go_to_shot": "Ir a la imagen {number}",
                    "previous_shot": "Imagen anterior",
                    "next_shot": "Imagen siguiente",
                    "view_larger": "Ver la imagen {number} más grande",
                    "filling": "Creando imágenes"
                }
            },
            "mediaclip": {
                "configurator": {
                    "choose_size": {
                        "label": "Elige tu tamaño"
                    },
                    "custom_size": {
                        "label": "Elige un tamaño personalizado"
                    },
                    "title": "Configurador"
                }
            },
            "product_options": {
                "title": "Opciones del producto"
            }
        },
        "success_page": {
            "banner": {
                "title": "¡Listo!",
                "sub_title": "Gracias por tu pedido. Nos ponemos a trabajar enseguida."
            },
            "title": "¿Qué pasa ahora?",
            "steps": {
                "order_confirmation": {
                    "title": "Confirmación de pedido",
                    "description": "Te enviaremos una confirmación de pedido (<strong>#{orderNumber}</strong>) a tu dirección de correo electrónico. Encuentra todos tus pedidos en tu cuenta.",
                    "description_fallback": "Te enviaremos una confirmación de pedido a tu dirección de correo electrónico. Encuentra todos tus pedidos en tu cuenta.",
                    "summary": {
                        "total_paid": "Total pagado (IVA incl.)",
                        "total_in_email": "Encontrarás el importe pagado en la confirmación de tu pedido.",
                        "show": "Ver tu pedido",
                        "hide": "Ocultar tu pedido",
                        "discount": "Descuento",
                        "discount_code": "Código de descuento {code}",
                        "shipping": "Gastos de envío",
                        "free": "Gratis",
                        "payment_fee": "Comisión de pago",
                        "other": "Otros",
                        "total": "Total"
                    }
                },
                "shipping_confirmation": {
                    "title": "Confirmación de envío",
                    "description": "Recibirás un correo electrónico cuando tus productos estén embalados y entregados al servicio de mensajería.",
                    "delivery_date": "Entrega prevista el"
                },
                "delivery_address": {
                    "title": "Dirección de entrega",
                    "description": "Tu(s) artículo(s) se entregarán en",
                    "info": "¿No estás en casa? Tu paquete se dejará con un vecino o en un punto de recogida."
                },
                "questions": {
                    "title": "¿Preguntas?",
                    "description": "¡Estamos encantados de ayudarte! Echa un vistazo a nuestra",
                    "customer_service_link": "página de atención al cliente",
                    "show_the_wow": {
                        "title": "¡Muestra el WOW!",
                        "description": "¡Muestra a tus amigos con qué te has dado un capricho!",
                        "instagram_label": "Instagram",
                        "facebook_label": "Facebook"
                    },
                    "news_letter": {
                        "label": "Exclusivo",
                        "title": "¿Convertirse en miembro WOW?",
                        "usp_1": "10% de descuento en tu próximo pedido",
                        "usp_2": "Descubre nuevos diseños y productos antes que nadie",
                        "usp_3": "Códigos de descuento y promociones exclusivos",
                        "button": "Hazte miembro"
                    }
                }
            },
            "page_title": "¡Pedido realizado!"
        },
        "checkout_page": {
            "form": {
                "delivery": {
                    "choose_pickup_location": "Elige tu punto de recogida",
                    "day_after_tomorrow_delivery": "¡Pídelo hoy, <b>pasado mañana</b> en casa!",
                    "deliver_at_pickup_location": "Seleccione un punto de recogida",
                    "latest_delivery": "Su paquete será entregado en su domicilio a más tardar el",
                    "no_address": "Introduzca su dirección de entrega para ver los métodos de envío disponibles.",
                    "no_pickup_locations": "No se encontraron puntos de recogida",
                    "opening_times": {
                        "label": "Horarios de apertura"
                    },
                    "selected_pickup_location": "Punto de recogida seleccionado:",
                    "show_other_pickup_locations": "Mostrar más puntos de recogida",
                    "tabs": {
                        "delivery": "Entrega",
                        "pickup": "Punto de recogida"
                    },
                    "tomorrow_delivery": "¡Pídelo hoy, <b>mañana</b> en casa!",
                    "available_from": "Disponible desde",
                    "error": "Se produjo un error al cargar las opciones de entrega.",
                    "postal_code_search": {
                        "button": "Buscar",
                        "label": "Código postal",
                        "placeholder": "Introduce el código postal..."
                    },
                    "show_on_map": "Ver en el mapa"
                },
                "payment": {
                    "no_address": "Introduce tu dirección de envío para ver los métodos de pago disponibles.",
                    "no_payment_required": "No se requiere pago.",
                    "no_payment_required_subtitle": "Tu pedido está completamente cubierto por tu código de descuento."
                }
            },
            "free": "Gratis",
            "messages": {
                "errors": {
                    "billing_address_missing": "Tu dirección de facturación está incompleta. Comprueba tu dirección e inténtalo de nuevo.",
                    "placing_order_failed": "Su pedido no se puede realizar en este momento.",
                    "shipping_address_missing": "Tu dirección de envío está incompleta. Comprueba tu dirección e inténtalo de nuevo."
                }
            },
            "overview": {
                "place_order_button": {
                    "label": "Realizar pedido"
                },
                "prices": {
                    "discount": "Descuento",
                    "shipping_costs": "Gastos de envío",
                    "shipping_surcharge": "Recargo",
                    "payment_fee": "Gastos de pago",
                    "subtotal": "Total parcial",
                    "total": "Total",
                    "you_save": "Ahorras",
                    "coupon_code": "Código de descuento",
                    "incl_vat": "IVA incluido: {amount}",
                    "promotion_discount": "Descuento promocional"
                },
                "quote_items": {
                    "count": "1 artículo | {count} artículos",
                    "quantity": "Cantidad: {quantity}"
                },
                "title": "Descripción general"
            },
            "payment": {
                "most_popular": "Más elegido"
            }
        },
        "configurator": {
            "sizes": {
                "most_chosen": "Más elegido"
            }
        },
        "search": {
            "title": "Resultados de búsqueda",
            "title_with_query": "Resultados de búsqueda para ‘{query}’",
            "products_title": "Productos",
            "heading_all": "Todos los diseños",
            "heading_with_query": "Resultados de búsqueda para ‘{query}’",
            "heading_no_results": "Sin resultados para ‘{query}’",
            "subtitle_no_results": "Comprueba la ortografía o prueba con un término más general.",
            "browse_by_product_title": "Explorar por producto"
        }
    },
    "slices": {
        "algolia_slider": {
            "price": {
                "else": "en otro caso",
                "from": "desde"
            }
        },
        "plp_before_after": {
            "before": "Antes",
            "after": "Después"
        },
        "plp_customer_images": {
            "image_alt": "Foto de cliente"
        },
        "pdp_before_after": {
            "before": "Antes",
            "after": "Después"
        },
        "contact_form_business": {
            "gift_timing_placeholder": "¿Cuándo quieres regalar las maletas?*",
            "referral_placeholder": "¿Cómo nos has conocido?*",
            "no_options": "No hay opciones disponibles",
            "selected_file": "Archivo seleccionado:",
            "required_fields": "Rellena todos los campos obligatorios.",
            "submit_error": "Se ha producido un error al enviar el formulario. Inténtalo de nuevo.",
            "invalid_file_type": "Tipo de archivo no válido. Solo se permiten JPEG, PNG, GIF, BMP, WEBP o SVG."
        },
        "banner_slider": {
            "excellent": "Excelente"
        }
    },
    "tools": {
        "mediaclip": {
            "configurator": {
                "designer": {
                    "loading": "Estamos preparando el configurador."
                },
                "footer": {
                    "buttons": {
                        "cancel": {
                            "label": "Cancelar"
                        },
                        "change_size": {
                            "label": "Cambiar tamaño ({size})"
                        },
                        "choose_size": {
                            "label": "Elige tu tamaño"
                        },
                        "to_photo": {
                            "label": "A la foto {number}"
                        }
                    }
                },
                "hexagon_photos_required_modal": {
                    "title": "Faltan fotos",
                    "description": "Las fotos {list} aún no están completas. Toca un marco vacío, sube tu foto e inténtalo de nuevo.",
                    "letter_collage_description": "Todavía no todos los marcos tienen una foto. Toca un marco vacío, sube tu foto e inténtalo de nuevo.",
                    "close": "Entendido"
                },
                "connection_lost_modal": {
                    "title": "Conexión perdida",
                    "description": "No podemos acceder a tu diseño en este momento. Comprueba tu conexión a internet y recarga la página; tu diseño se guarda automáticamente.",
                    "reload": "Recargar la página"
                },
                "project_title": {
                    "error": "No se pudo guardar",
                    "label": "Título del proyecto",
                    "placeholder": "Introduce un título...",
                    "saved": "Guardado",
                    "saving": "Guardando..."
                }
            }
        },
        "landscape_popup": {
            "text": "Esta página funciona mejor si gira la pantalla. Gire la pantalla para continuar con su pedido."
        }
    },
    "checkout": {
        "billing_address": {
            "title": "Dirección de facturación"
        },
        "delivery": {
            "preferences": {
                "label": "¿Qué entrega prefieres?",
                "express": {
                    "description": "¡Pide hoy y recíbelo pasado mañana!",
                    "label": "Entrega exprés"
                },
                "regular": {
                    "label": "Entrega estándar"
                }
            },
            "title": "Entrega",
            "delivery_date_info": "Tu pedido se entregará como muy tarde el ",
            "info": "Introduce tus datos de envío para ver las opciones de entrega disponibles"
        },
        "form": {
            "address_finder": {
                "invalid_address": "No se ha encontrado la dirección introducida. Comprueba los datos e inténtalo de nuevo.",
                "label": "Buscador de direcciones",
                "placeholder": "Empieza a escribir para buscar tu dirección",
                "address_filled": "Tu dirección se ha rellenado.",
                "select_address": "Selecciona tu dirección de la lista."
            },
            "city": {
                "label": "Ciudad",
                "placeholder": "Ciudad",
                "invalid_characters": "Usa solo letras, espacios, guiones (-) y apóstrofos ('), con un máximo de 100 caracteres."
            },
            "company": {
                "label": "Nombre de la empresa",
                "placeholder": "Nombre de la empresa"
            },
            "country": {
                "label": "País"
            },
            "email": {
                "label": "Dirección de correo electrónico",
                "placeholder": "Dirección de correo electrónico",
                "label_track_trace": "Correo electrónico para el seguimiento del envío"
            },
            "first_name": {
                "label": "Nombre",
                "placeholder": "Nombre"
            },
            "house_number": {
                "label": "Número",
                "placeholder": "p. ej. 1"
            },
            "house_number_suffix": {
                "label": "Complemento",
                "placeholder": "p. ej. A"
            },
            "order_type": {
                "corporate": {
                    "label": "Empresa"
                },
                "private": {
                    "label": "Particular"
                },
                "title": "Tipo de pedido"
            },
            "phone_number": {
                "label": "Número de teléfono",
                "placeholder": "Número de teléfono",
                "invalid_characters": "Usa solo números, espacios y + - ( ), con un máximo de 20 caracteres."
            },
            "same_address": {
                "label": "La dirección de facturación y la de envío son la misma"
            },
            "street_name": {
                "label": "Calle",
                "placeholder": "Calle"
            },
            "surname": {
                "label": "Apellidos",
                "placeholder": "Apellidos"
            },
            "vat_number": {
                "label": "Número de IVA",
                "placeholder": "Número de IVA"
            },
            "zipcode": {
                "label": "Código postal",
                "placeholder_example": "p. ej. {example}",
                "invalid": "Introduce un código postal válido, p. ej. {example}."
            },
            "save_in_address_book": {
                "label": "Guardar en la libreta de direcciones"
            },
            "newsletter_subscribe": {
                "label": "Mantenme informado/a sobre noticias, inspiración y ofertas exclusivas por correo electrónico"
            },
            "account_type": {
                "title": "Cuenta",
                "guest": {
                    "label": "Continuar como invitado"
                },
                "create": {
                    "label": "Crear cuenta"
                },
                "email_taken": "Ya existe una cuenta con esta dirección de correo electrónico.",
                "login_link": "Iniciar sesión",
                "password_required": "Introduce dos veces la misma contraseña para crear tu cuenta.",
                "privacy_required": "Debes aceptar la Política de privacidad para crear tu cuenta."
            }
        },
        "payment": {
            "title": "Pago",
            "ideal_wero": {
                "description": "iDEAL {'|'} Wero"
            },
            "paypal": {
                "description": "Paypal"
            }
        },
        "shipping_address": {
            "title": "Dirección de envío"
        },
        "customer_addresses": {
            "add_new": "Agregar nueva dirección",
            "create_modal_title": "Nueva dirección",
            "edit_modal_title": "Editar dirección",
            "delete_modal_title": "Eliminar dirección"
        },
        "address_book": {
            "add_new": "Añadir nueva dirección",
            "default_billing": "Dirección de facturación predeterminada",
            "default_shipping": "Dirección de envío predeterminada",
            "create_modal": {
                "title_shipping": "Nueva dirección de envío",
                "title_billing": "Nueva dirección de facturación",
                "confirm": "Guardar",
                "cancel": "Cancelar"
            },
            "edit_modal": {
                "title": "Editar dirección",
                "confirm": "Guardar",
                "cancel": "Cancelar"
            },
            "delete_modal": {
                "title": "Eliminar dirección",
                "confirm": "Eliminar",
                "cancel": "Cancelar",
                "description": "¿Estás seguro de que quieres eliminar esta dirección? Esta acción no se puede deshacer."
            },
            "save_failed": "Error al guardar. Por favor, inténtalo de nuevo.",
            "delete_failed": "Error al eliminar. Por favor, inténtalo de nuevo.",
            "order_only": "Solo para este pedido"
        }
    }
}
